@for (fee of fees(); track fee.feeReference) {
  @switch (fee.feeType) {
    @case ("Core") {
      <div class="fee core" i18n="@@product.fees.core.amount">+{{ fee.value | currency }} Core Deposit</div>
    }
    @case ("EHC") {
      <div class="fee ehc" i18n="@@product.fees.ehc.amount">+{{ fee.value | currency }} EHC Fee</div>
    }
    @default {
      <div class="fee unknown" i18n="@@product.fees.unknown-type.amount">{{ fee.value | currency }} {{ fee.feeType }}</div>
    }
  }
}
